import PersonInformation from "./SVG/single-neutral-actions-information.svg?react";

const PersonInformationIcon = () => {
  return <PersonInformation />;
};

export default PersonInformationIcon;
